// /ProfilePage/components/UserProfileCard.js

import React from 'react';
import { Avatar, Card, Typography } from '@mui/material';
import {
  getInitials,
  formatDisplayName,
  getRoleLabel,
  isValidUrl,
} from '../utils/utils';

const defaultAvatar = '/path/to/default-avatar.png'; // Substitua pelo caminho real se houver

function UserProfileCard({ user }) {
  // console.log('Dados recebidos no Card:', user);
  if (!user) return null;

  // A correção (usando um "alias"):
  const { nome, email, avatar: foto, tipo } = user;

  const photoURL = foto && isValidUrl(foto) ? foto : defaultAvatar;

  return (
    <Card
      sx={{
        bgcolor: '#2C2C2F',
        textAlign: 'center',
        p: 4,
        borderRadius: 3,
        color: '#fff',
      }}
    >
      <Avatar
        src={photoURL}
        sx={{
          width: 95,
          height: 95,
          fontSize: 40,
          bgcolor: '#4E4E52',
          color: '#fff',
          mb: 2,
          mx: 'auto',
        }}
      >
        {photoURL === defaultAvatar ? getInitials(nome) : null}
      </Avatar>
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
        noWrap
        sx={{
          maxWidth: 260,
          mx: 'auto',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {formatDisplayName(nome)}
      </Typography>
      <Typography
        color="#bdbdbd"
        noWrap
        sx={{
          maxWidth: 280,
          mx: 'auto',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {email}
      </Typography>
      <Typography sx={{ mt: 1, fontWeight: 'bold', fontSize: '1.4rem' }}>
        {getRoleLabel(tipo)}
      </Typography>
    </Card>
  );
}

export default UserProfileCard;
